"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var withContext_1 = __importDefault(require("./hoc/withContext"));
var visibleComponentContext_1 = __importDefault(require("./hoc/visibleComponentContext"));
var props_1 = __importDefault(require("./context/props"));
var useUpdatePopoverPosition_1 = __importDefault(require("./hooks/useUpdatePopoverPosition"));
var Popover_1 = __importDefault(require("../Popover"));
var Header_1 = __importDefault(require("./Header"));
var Form_1 = __importDefault(require("./Form"));
var useStyles_1 = __importDefault(require("./useStyles"));
var constants_1 = require("./constants");
var Feedback = function (props) {
    var translate = props.translate, onSubmitForm = props.onSubmitForm, anchorEl = props.anchorEl, anchorPosition = props.anchorPosition, open = props.open, onClose = props.onClose, width = props.width, anchorOrigin = props.anchorOrigin, transformOrigin = props.transformOrigin, isLoading = props.isLoading, _a = props.maxFilesSize, maxFilesSize = _a === void 0 ? constants_1.MAX_FILE_SIZE : _a, _b = props.accept, accept = _b === void 0 ? '.pdf, .jpg, .png, .mov, .mpeg' : _b;
    var classes = (0, useStyles_1.default)({ width: width });
    var popoverRef = (0, react_1.createRef)();
    (0, useUpdatePopoverPosition_1.default)(popoverRef);
    return (react_1.default.createElement(props_1.default, { translate: translate, onClose: onClose, onSubmitForm: onSubmitForm, maxFilesSize: maxFilesSize, accept: accept, isLoading: isLoading },
        react_1.default.createElement(Popover_1.default, { open: open, anchorEl: anchorEl, anchorPosition: anchorPosition, anchorOrigin: anchorOrigin, transformOrigin: transformOrigin, action: popoverRef, classes: { paper: classes.root } },
            react_1.default.createElement(Header_1.default, null),
            react_1.default.createElement(Form_1.default, null))));
};
exports.default = (0, visibleComponentContext_1.default)((0, withContext_1.default)(Feedback));
